<template>
  <div>
    <div class="hero-section">
        <div class="container">
            <h1 class="page-title">Гарын авлага</h1>
            <p class="page-subtitle">
                
            </p>
        </div>
    </div>
    <div style="max-width: 1200px; margin: 0 auto;">
        <task-video-cards :tasks="tasks" @task-clicked="handleTaskClick" />
    </div>
  </div>
</template>
<script>
import { request } from "@/api/all";
import TaskVideoCards from "./task-video-cards.vue";

export default {
  components: {
    TaskVideoCards
  },
  props: {
    comp: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      tasks: []
    };
  },
  mounted() {
    this.loadTasks(this.comp.locTypeId1);
  },
  methods: {
    loadTasks(typeId) {
      //console.log('=>', this.comp);
      request({
        api: { method: "POST", url: "TaskCore/GetCoreList" },
        data: {
          skip: 0,
          size: 50,
          ot: 357,
          model: {
            isPublic: true,
            locTypeId1: typeId
          }
        },
        store: this.$store
      }).then(res => {
        if (res != false) {
          this.tasks = res.data.tasks;
        }
      });
    },
    handleTaskClick(task) {
      // Handle click for non-YouTube tasks (e.g., navigate to detail page)
      console.log("Task clicked:", task);
      // You can emit an event or navigate to a detail page here
      this.$emit("task-selected", task);
    }
  }
};
</script>
<style scoped>

.hero-section {
  background: 
    linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)),
    url('https://res.gosmart.mn/apps/egazar/cover2.jpg');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  filter: grayscale(100%);
  color: white;
  padding: 80px 0 60px;
  text-align: center;
  position: relative;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.page-title {
  color: white;
  font-size: 3rem;
  font-weight: 700;
  margin-bottom: 20px;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
}

.page-subtitle {
  color: white;
  font-size: 1.2rem;
  opacity: 0.9;
  max-width: 400px;
  margin: 0 auto;
  text-transform: uppercase;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
}
</style>